import React, { useState } from 'react';
import { FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const CertificatePrintPreviewModal = ({ show, certificates, onClose }) => {
  const [currentPage, setCurrentPage] = useState(0);

  if (!show || !certificates || certificates.length === 0) {
    return null;
  }

  const currentCertificate = certificates[currentPage];

  const handlePrevious = () => {
    setCurrentPage((prev) => (prev > 0 ? prev - 1 : certificates.length - 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => (prev < certificates.length - 1 ? prev + 1 : 0));
  };

  const handlePrintAll = () => {
    const printWindow = window.open('', '', 'width=800,height=600');

    let certificateStyles = '';
    if (certificates.length > 0) {
      try {
        const firstCertificateHTML = certificates[0].certificate || certificates[0];
        const parser = new DOMParser();
        const doc = parser.parseFromString(firstCertificateHTML, 'text/html');
        const styleElement = doc.querySelector('style');
        if (styleElement) {
          certificateStyles = styleElement.innerHTML.replace(/body\s*{\s*[^}]*\s*}/gi, '').trim();
        }
      } catch (error) {
        console.error('[v0] Error extracting certificate styles:', error);
      }
    }

    let htmlContent = `
      <!DOCTYPE html>
      <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Print All Certificates</title>
          <style>
            @page {
              size: A4 portrait;
              margin: 0.5cm;
            }
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            html, body {
              margin: 0;
              padding: 0;
              width: 100%;
            }
            body {
              background: white;
            }
            .certificate-container {
              width: 100%;
              height: auto;
              min-height: 100vh;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 20px;
              page-break-after: always;
              page-break-inside: avoid;
              background: white;
            }
            .certificate-container:last-child {
              page-break-after: avoid;
            }
            .certificate-wrapper {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
            img {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              color-adjust: exact !important;
              max-width: 100%;
              height: auto;
            }
            ${certificateStyles}
            @media print {
              body {
                background: white;
                margin: 0 !important;
                padding: 0 !important;
                width: 100%;
                height: auto;
              }
              .certificate-container {
                page-break-after: always;
                page-break-inside: avoid;
                margin: 0;
                padding: 10px 0;
                height: auto;
                min-height: auto;
                background: white;
                display: flex;
                align-items: flex-start;
                justify-content: center;
              }
              .certificate-container:last-child {
                page-break-after: avoid;
              }
            }
          </style>
        </head>
        <body>
    `;

    certificates.forEach((certificateObj, index) => {
      try {
        const certificateHTML = certificateObj.certificate || certificateObj;
        const parser = new DOMParser();
        const doc = parser.parseFromString(certificateHTML, 'text/html');
        const certificateContent = doc.body.innerHTML;
        htmlContent += `
          <div class="certificate-container">
            <div class="certificate-wrapper">
              ${certificateContent}
            </div>
          </div>
        `;
      } catch (error) {
        console.error('[v0] Error processing certificate:', error);
      }
    });

    htmlContent += `
        </body>
      </html>
    `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();

    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
    }, 3000);
  };

  const handlePrintCurrent = () => {
    const printWindow = window.open('', '', 'width=800,height=600');

    try {
      const certificateHTML = currentCertificate.certificate;
      const parser = new DOMParser();
      const doc = parser.parseFromString(certificateHTML, 'text/html');
      const styleElement = doc.querySelector('style');
      let certificateStyles = '';
      if (styleElement) {
        certificateStyles = styleElement.innerHTML.replace(/body\s*{\s*[^}]*\s*}/gi, '').trim();
      }
      const certificateContent = doc.body.innerHTML;

      const printableHTML = `
        <!DOCTYPE html>
        <html lang="en">
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Print Certificate</title>
            <style>
              @page {
                size: A4 portrait;
                margin: 0.5cm;
              }
              * {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
                color-adjust: exact !important;
              }
              html, body {
                margin: 0;
                padding: 0;
                width: 100%;
                height: 100%;
                background: white;
              }
              body {
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: 100vh;
              }
              img {
                max-width: 100%;
                height: auto;
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }
              ${certificateStyles}
              @media print {
                body {
                  margin: 0 !important;
                  padding: 0 !important;
                  background: white;
                  display: flex;
                  align-items: flex-start;
                  justify-content: center;
                  height: auto;
                }
              }
            </style>
          </head>
          <body>
            ${certificateContent}
          </body>
        </html>
      `;

      printWindow.document.write(printableHTML);
      printWindow.document.close();

      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
      }, 3000);
    } catch (error) {
      console.error('[v0] Error processing current certificate for print:', error);
    }
  };

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
        }}
        onClick={onClose}
      >
        <div
          style={{
            backgroundColor: '#ffffff',
            borderRadius: '12px',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
            width: '90%',
            maxWidth: '900px',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '20px',
              borderBottom: '1px solid #e5e7eb',
              backgroundColor: '#f9fafb',
            }}
          >
            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
              Certificate Print Preview
            </h3>
            <button
              onClick={onClose}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#6b7280',
              }}
            >
              <FaTimes />
            </button>
          </div>

          <div
            style={{
              flex: 1,
              overflowY: 'auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px',
              backgroundColor: '#f3f4f6',
            }}
          >
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <iframe
                style={{
                  width: '400px',
                  height: '600px',
                  border: 'none',
                  borderRadius: '8px',
                
                }}
                srcDoc={currentCertificate.certificate}
                title={`Certificate ${currentPage + 1}`}
              />
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '20px',
              borderTop: '1px solid #e5e7eb',
              backgroundColor: '#f9fafb',
            }}
          >
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={handlePrevious}
                disabled={certificates.length <= 1}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '8px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  backgroundColor: '#ffffff',
                  cursor: certificates.length <= 1 ? 'not-allowed' : 'pointer',
                  opacity: certificates.length <= 1 ? 0.5 : 1,
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => {
                  if (certificates.length > 1) {
                    e.target.style.backgroundColor = '#f3f4f6';
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#ffffff';
                }}
              >
                <FaChevronLeft /> Previous
              </button>

              <button
                onClick={handleNext}
                disabled={certificates.length <= 1}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '8px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  backgroundColor: '#ffffff',
                  cursor: certificates.length <= 1 ? 'not-allowed' : 'pointer',
                  opacity: certificates.length <= 1 ? 0.5 : 1,
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => {
                  if (certificates.length > 1) {
                    e.target.style.backgroundColor = '#f3f4f6';
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#ffffff';
                }}
              >
                Next <FaChevronRight />
              </button>
            </div>

            <div style={{ fontSize: '14px', color: '#6b7280', fontWeight: '500' }}>
              Page {currentPage + 1} of {certificates.length}
            </div>

            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={handlePrintCurrent}
                style={{
                  padding: '10px 16px',
                  backgroundColor: '#6366f1',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#4f46e5';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#6366f1';
                }}
              >
                Print Current
              </button>

              <button
                onClick={handlePrintAll}
                style={{
                  padding: '10px 16px',
                  backgroundColor: '#184778',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#143a5f';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#184778';
                }}
              >
                Print All ({certificates.length})
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CertificatePrintPreviewModal;